module.exports = __webpack_public_path__ + "img/stats-banner-device-with-pin.dc53939e.svg";